import { List } from 'antd'
import React from 'react'
import { FormConfigurationType } from '~/features/formConfiguration/common'
import { ListItem } from './components/ListItem'

type Props = {
  formConfigurations: FormConfigurationType[]
  onUpdateSteps: (formConfiguration: FormConfigurationType) => void
  onUpdate: (formConfiguration: FormConfigurationType) => void
  onDelete: (formConfiguration: FormConfigurationType) => void
}

export const FormConfigurationList: React.FC<Props> = ({
  formConfigurations,
  onUpdate,
  onDelete,
  onUpdateSteps,
}) => {
  return (
    <List
      dataSource={formConfigurations}
      renderItem={formConfiguration => {
        return (
          <List.Item key={formConfiguration.id} style={{ cursor: 'pointer' }}>
            <ListItem
              formConfiguration={formConfiguration}
              onUpdateSteps={() => onUpdateSteps(formConfiguration)}
              onUpdate={() => onUpdate(formConfiguration)}
              onDelete={() => onDelete(formConfiguration)}
            />
          </List.Item>
        )
      }}
    ></List>
  )
}
